import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import {
  UTILITY_USER_ROLE_ADMIN,
  UTILITY_USER_ROLE_PARTNER,
  UTILITY_USER_ROLE_PARTNER_ADMIN,
} from 'common/utility/userRoles';
import { canManagePartnerApiKeys } from 'common/utility/partnerApiKeys';
import { SCREEN_ID_UTILITY_PARTNER_SETTINGS_API_KEYS } from 'client/constants/screenIds';

import UtilityPartnerActions from 'client/actions/UtilityPartner';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedUtilityRoles from 'client/helpers/allowedUtilityRoles';
import branch from 'client/core/branch';
import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrUtilityPartnerApiKeys from 'client/components/SrUtilityPartnerApiKeys/SrUtilityPartnerApiKeys';

@withTransitionHook
@allowedUtilityRoles({
  roles: [UTILITY_USER_ROLE_ADMIN, UTILITY_USER_ROLE_PARTNER, UTILITY_USER_ROLE_PARTNER_ADMIN],
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_UTILITY_PARTNER_SETTINGS_API_KEYS)
@withScrollToTop
@branch(({ match }) => ({
  utilityPartner: ['utilityPartners', 'bySlug', match.params.partnerSlug],
  utilityUser: ['utilityUser'],
}))
class UtilityPartnerSettingsApiKeysPage extends Component {
  static getPageMetadata = () => ({ pageTitle: 'API Keys' });

  static fetchData(match, inject) {
    return UtilityPartnerActions.getBySlug(inject, {
      slug: match.params.partnerSlug,
      forceRefresh: true,
    });
  }

  render() {
    const { utilityUser, utilityPartner, utilityApiClient, isTransitioning, history, match } = this.props;
    if (isTransitioning) return null;
    const settingsPath = `/utility-profit/${match.params.partnerSlug}/settings`;
    if (!canManagePartnerApiKeys(utilityUser, utilityPartner)) {
      return <Redirect to={settingsPath} />;
    }
    return (
      <SrPartnerPageV2
        backUrl={settingsPath}
        navbarTitle={utilityPartner.name}
        navbarImage={utilityPartner.logoUrl}
        pageHeader="API Keys"
        redirectToLastLocation={false}
      >
        <SrUtilityPartnerApiKeys
          key={`${utilityPartner.id}-${utilityUser.id}`}
          utilityPartner={utilityPartner}
          utilityApiClient={utilityApiClient}
          onAccessDenied={() => history.replace(settingsPath)}
        />
      </SrPartnerPageV2>
    );
  }
}

UtilityPartnerSettingsApiKeysPage.displayName = 'UtilityPartnerSettingsApiKeysPage';

export default UtilityPartnerSettingsApiKeysPage;
